import { render, staticRenderFns } from "./pinterestIcon.vue?vue&type=template&id=045d2ec6&scoped=true"
import script from "./pinterestIcon.vue?vue&type=script&lang=js"
export * from "./pinterestIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d2ec6",
  null
  
)

export default component.exports